import { STANDARDIZED_DATA_FIELDS } from '../../../helpers/standardizedDataFields';
import { isFixedFieldTitle } from '../../../helpers/adressHelpers/householdFields';

// Vaste gegevens staan op de kaart 'Vaste gegevens', niet als eigen gegeven.
// AI-CONTEXT: See docs/features/huishouden-vaste-gegevens.md (T4)

const Datalist = () => {
  return (
    <>
      {STANDARDIZED_DATA_FIELDS.filter((title) => !isFixedFieldTitle(title)).map((title) => (
        <option key={title} value={title} />
      ))}
    </>
  );
};

export default Datalist;
